<template>
    <div class="view view--news">
        <data-table
            class="has-margin-b45"
            v-bind:data="tableData"
            v-on:sort="sortDataTable"
        ></data-table>

        <btn
            class="is-success"
            type="default"
            href="/admin#/news/create"
            v-html="__('+ Add news')"
        ></btn>

        <modal
            class="is-narrow"
            v-bind:title="__('Are you sure?')"
            v-bind:is-open="isOpenDeleteModal"
            v-on:close-modal="isOpenDeleteModal = false"
        >
            <template v-slot:body>
                <p
                    class="has-text-center"
                    v-html="
                        __(
                            'Are you sure you want to delete this news?<br />This action cannot be undone.'
                        )
                    "
                ></p>
            </template>
            <template v-slot:footer>
                <div class="has-padding-t10">
                    <div class="columns">
                        <div class="column">
                            <btn
                                class="is-block"
                                type="cancel"
                                v-html="__('Cancel')"
                                v-on:click="isOpenDeleteModal = false"
                            >
                            </btn>
                        </div>
                        <div class="column">
                            <btn
                                class="is-block"
                                type="error"
                                v-html="__('Delete')"
                                v-on:click="deleteNews"
                            >
                            </btn>
                        </div>
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import MessageHandler from '../../messageHandler';
import store from '../../store';
import { Btn } from '@teamfurther/cinderblock';
import { DataTable } from '@teamfurther/cinderblock';
import { Modal } from '@teamfurther/cinderblock';
import NewsRepository from '../../repositories/NewsRepository';

export default {
    components: {
        Btn,
        DataTable,
        Modal
    },
    created: function() {
        this.newsRepository = new NewsRepository();
    },
    data: function() {
        return {
            deletingId: null,
            errors: {},
            isOpenDeleteModal: false,
            news: [],
            newsRepository: null,
            tableData: {
                columnNames: {
                    title: this.__('Title'),
                    shortDescription: this.__('Short description')
                },
                items: [],
                sortableColumns: ['title']
            }
        };
    },
    methods: {
        deleteNews: async function() {
            try {
                await this.newsRepository.deleteNews(this.deletingId);

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('News was successfully deleted.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                await this.getNews();
            } catch (error) {
            } finally {
                this.isOpenDeleteModal = false;
            }
        },
        getNews: async function(sort = '') {
            try {
                this.news = await this.newsRepository.getNews(sort);

                let items = [];
                this.news.forEach(news => {
                    items.push(this.transformNewsData(news));
                });

                this.$set(this.tableData, 'items', items);
            } catch (error) {}
        },
        showDeleteModal: function(data) {
            this.deletingId = data.id;
            this.isOpenDeleteModal = true;
        },
        transformNewsData: function(news) {
            let actions = [];

            actions.push({
                class: 'is-red',
                method: 'showDeleteModal',
                title: this.__('Delete')
            });
            actions.push({
                title: this.__('Edit'),
                url: '/admin#/news/' + news.id + '/edit'
            });

            return {
                values: {
                    id: news.id,
                    shortDescription:
                        news.short_description.length > 80
                            ? `${news.short_description.substring(0, 80)}...`
                            : news.short_description,
                    title: news.title
                },
                actions: actions
            };
        },
        sortDataTable(sortByColumn) {
            if (
                this.tableData.sortableColumns.includes(
                    sortByColumn.replace('-', '')
                )
            ) {
                this.getNews(sortByColumn);
            }
        }
    },
    mounted: function() {
        this.getNews();
    }
};
</script>
